import { httpCall } from "../../../common/util";
import appConstants from "../../../config/appConstants";

const communicationListEndpoint = "/1.0/organization/communication";

export const fetchCommunicationList = () => {
  return httpCall({
    method: appConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: communicationListEndpoint,
  });
};

export const updateCommunication = (params) => {
  return httpCall({
    method: appConstants.httpMethod.PUT,
    headers: { "Content-Type": "application/json" },
    url: communicationListEndpoint,
    data: params,
  });
};
